{
  "summary": "Summary",
  "employees": "Employees",
  "payments": "Payments",
  "default_fees": "Default Fees",
  "primary": "Primary",
  "commitment": "Commitment",
  "payment": "Payment",
  "cpl": "CPL",
  "post-processing": "Post Processing",
  "loss-payee": "Loss Payee",
  "mailing": "Mailing",
  "if-you-leav": "If you leave this page, your changes will not be saved",
  "it-is-necessary-to-save": "It is necessary to save every change in this section, please save before returning to the order.",
  "loan-processor": "Loan Processor",
  "edit-employee": "Edit employee",
  "not-employees-added": "No Employees added for this company yet.",
  "work-number": "Work Number",
  "phone-number": "Phone Number",
  "actions": "Actions",
  "loan-originator": "Loan Originator",
  "assistant": "Assistant",
  "refinance": "Refinance",
  "heloc": "HELOC",
  "routing": "Routing",
  "account": "Account",
  "check": "Check",
  "holdback": "Holdback",
  "wire": "Wire",
  "borrower": "Borrower",
  "application": "Application",
  "appraisal": "Appraisal",
  "assignment-consideration": "Assignment Consideration",
  "courier": "Courier",
  "credit-report": "Credit Report",
  "document-preparation": "Document Preparation",
  "e-recording-fee": "E-Recording Fee",
  "endorsement": "Endorsement",
  "flood-certification": "Flood Certification",
  "hazard-insurance": "Hazard Insurance",
  "home-warranty": "Home Warranty",
  "insurance": "Insurance",
  "lenders-policy": "Lender’s Policy",
  "notary": "Notary",
  "origination": "Origination",
  "owners_policy": "Owner’s Policy",
  "payoff": "Payoff",
  "property-owners-association-resale-certificate": "Property Owner’s Association - Resale Certificate",
  "property-owners-association-transfer-fee": "Property Owner’s Association - Transfer Fee",
  "property-tax": "Property Tax",
  "real-estate-agent-commission": "Real Estate Agent Commission",
  "real-estate-broker-commission": "Real Estate Broker Commission",
  "recording-fee": "Recording Fee",
  "reimbursement": "Reimbursement",
  "remittance-endorsment": "Remittance: Endorsement",
  "remittance-ltp": "Remittance: LTP",
  "remittance-otp": "Remittance: OTP",
  "sales-tax": "Sales Tax",
  "seller-finance": "Seller Finance",
  "settlement-fee": "Settlement Fee",
  "survey": "Survey",
  "tax-certificate": "Tax Certificate",
  "tiga": "TIGA",
  "transfer-tax": "Transfer Tax",
  "wire-fee": "Wire Fee",
  "excluded": "Excluded",
  "unclassified": "Unclassified",
  "construction_binder": "Construction Binder",
  "section": "Section",
  "description": "Description",
  "payee": "Payee",
  "amount": "Amount",
  "none": "None",
  "tax-service": "Tax service",
  "companyEmployees": "{{company}} Employees",
  "createNewEmployeeAt": "Create New Employee at {{company}}"
}
